@if (visible) {
  <nb-card [ngClass]="{'no-shadow': !boxShadow}" nbSpinnerStatus="primary" class="chart-card"
    [style.margin-bottom]="'1rem'"
    [style.border]="'none'"
    [style.position]="'relative'">
    @if (loading) {
      <div class="grid-loading-overlay">
        <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
      </div>
    }
    <nb-card-header>
      <!-- <fa-icon class="excel-icon" (click)="excelMessageHandler()" icon="file-excel"></fa-icon> -->
      @if (allowZoom && zoomEnabled) {
        <fa-icon [icon]="['fas', 'search-minus']" class="me-2" (click)="resetZoom()"></fa-icon>
      }
      <!-- <fa-icon *ngIf="!report && showExportButton" [icon]="['fas', 'file-download']" class="me-2" (click)="export()"></fa-icon>
      <fa-icon *ngIf="!report && showExpandButton" [icon]="['fas', 'expand-arrows-alt']" (click)="expand(expandedDialog)"></fa-icon> -->
      <!-- <app-consumption-type-button [energyOrCarbon]="'energy'"></app-consumption-type-button> -->
    </nb-card-header>
    @if (chosenProvider !== undefined && chosenProvider !== null && !displayNoData) {
      <div class="info">
        @if(energyOrCarbon) {
          <span class="cons-type">
            <app-consumption-type-button [energyOrCarbon]="energyOrCarbon"></app-consumption-type-button>
          </span>
        }
        {{ 'Objective type' | translate }} :
        <span (click)="openProviders()" class="link">
          {{ chosenProvider }}
          @if (providerId && providerId > 0 && selectedToUPathway?.name) {
            - {{ selectedToUPathway.name }}
          }
        </span>
        @if (perimeters.length > 1 && providerId === -1) {
          {{ 'weighted by areas' | translate }}
        }
      </div>
    }
    <nb-card-body>
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="options"
        [oneToOne]="true"
        (chartInstance)="saveInstance($event)"
        style="display: block;"
        class="chart"
      ></highcharts-chart>
      @if (displayNoData) {
        <div class="chart-no-data">
          <i class="fa-kit fa-thin-lightbulb-circle-question icon"></i>
          <br>
          <span>
            {{ noConsumptionSentence }}
          </span>
        </div>
      }
      @if (alert) {
        <nb-alert [accent]="alert.status" class="chart-alert">
          <div class="chart-alert-title">{{ alert.title}}
            @if (alert.message) {
              <span (click)="displayMessage(alertDialog)" class="chart-alert-more-info">
                ({{ 'pages.common.charts.base-chart.more_info' | translate }})
              </span>
            }
          </div>
        </nb-alert>
      }
      </nb-card-body>
    </nb-card>
  }

  <ng-template #expandedDialog let-data let-ref="dialogRef">
    <nb-card class="expanded-chart-dialog">
      <nb-card-body>
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="options"
          [oneToOne]="true"
          style="display: block; width: 100%; height: 85vh;"
        ></highcharts-chart>
      </nb-card-body>
    </nb-card>
  </ng-template>

  <ng-template #alertDialog let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-header>{{ 'pages.common.charts.lifecycle-chart.alert_popup_header' | translate }}</nb-card-header>
      <nb-card-body>{{ alert.message }}</nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="ref.close()">{{'pages.common.charts.base-chart.close' | translate }}</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>
